module.exports = __webpack_public_path__ + "8a5356e9/img/saly-icon.39e12342.jpg";